// extracted by mini-css-extract-plugin
export default {"root":"StatusLine_root__HdQJr","dot":"StatusLine_dot__pfuAb"};